import * as S from './MainContentHeader.styles';

export const MainContentHeader = S.MainContentHeader;
